
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vendedor",
      function () {
        return require("private-next-pages/vendedor.js");
      }
    ]);
  